document.addEventListener("DOMContentLoaded", () => {
  const targetNode = document.body;

  let badgeVisible = false;

  const observer = new MutationObserver(() => {
    const badge = document.querySelector(".final-sale-badge");

    if (badge && !badgeVisible) {
      const itemMapper = document.querySelector('.discount-text');
      if (itemMapper) {
        itemMapper.style.display = "block";
      }
      badgeVisible = true;
    } else if (!badge && badgeVisible) {
      
     const itemMapper = document.querySelector('.discount-text');
      if (itemMapper) {
        itemMapper.style.display = "none";
      }
      badgeVisible = false;
    }
  });

  observer.observe(targetNode, {
    childList: true,
    subtree: true,
  });

  
  console.log(document.querySelectorAll('[data-block-type="description"]').length,'l2222engjtjttt')
  if(document.querySelectorAll('[data-block-type="description"]').length > 0) {
      const description = document.querySelector('[data-block-type="description"]');
      const contentText = description.innerText || description.textContent;
      console.log(contentText.length,'lengjtjttt')
      if (contentText.length > 350) {
          const toggleButton = document.createElement('a');
          toggleButton.id = 'toggleButton';
          toggleButton.href = 'javascript:void(0)';
          toggleButton.classList.add('toggle-text-link')
          toggleButton.classList.add('link')
          toggleButton.textContent = 'Show more';
          
          description.parentNode.insertBefore(toggleButton, description.nextSibling);
  
          description.classList.add('collapsed');
  
          toggleButton.addEventListener('click', function () {
              if (description.classList.contains('expanded')) {
                  description.classList.remove('expanded');
                  toggleButton.textContent = 'Show more';
              } else {
                  description.classList.add('expanded');
                  toggleButton.textContent = 'Show less';
              }
          });
      }
  }

});